import * as React from 'react'
import './styles.scss'

interface LabelProps {
  htmlFor: string
  title: string
}

const Label = ({ htmlFor, title }: LabelProps) => {
  return (
    <label className="input-label" htmlFor={htmlFor}>
      {title}
    </label>
  )
}

interface SpanErrorProps {
  errorMessage?: string
  hasError: boolean
}

const Error = ({
  hasError,
  errorMessage = 'Campo obrigatório',
}: SpanErrorProps) => {
  return (
    <div className="input-span-error-container">
      {hasError && (
        <span className="input-span-error">{`** ${errorMessage}`}</span>
      )}
    </div>
  )
}

interface FieldProps extends React.DetailedHTMLProps<
React.InputHTMLAttributes<HTMLInputElement>,
HTMLInputElement
> {}

const Field = React.forwardRef<HTMLInputElement, FieldProps>( function Field ({
  ...rest
}, ref) {
  return <input className="input-input" { ...{ref} } {...rest} />
})

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

const NewInput = ({ children, ...rest }: ContainerProps) => {
  return (
    <div className="input-component">
      <div {...rest}>{children}</div>
    </div>
  )
}

NewInput.Field = Field
NewInput.Label = Label
NewInput.Error = Error

export { NewInput }

